import { render } from "./BaseDatePicker.vue?vue&type=template&id=63aa4c56&scoped=true"
import script from "./BaseDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseDatePicker.vue?vue&type=script&lang=js"

import "./BaseDatePicker.vue?vue&type=style&index=0&id=63aa4c56&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63aa4c56"]])

export default __exports__